export const openEmailDraft = (emailTo: string, subject: string = '', emailBody: string = '') => {
  window.open(
    'mailto:' + emailTo +
    '?subject=' + subject +
    '&body=' + emailBody
  );
};
